import React from "react";
import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";

const SiteHeaderV2Styled = styled.div`
    font-size: 50px;
    text-align: center;
    padding: ${convertPxToRem(10)};
    line-height: 100%;
`;

// component
export const SiteHeaderV2 = () => {
    return <SiteHeaderV2Styled>Site Header V2</SiteHeaderV2Styled>;
};

export default SiteHeaderV2;
